/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import Modal from "../Modal";
import SystemErrorModal from "../SystemErrorModal";
import Spinner from "../icons/Spinner";
import messages from "../../helpers/messages";

function DeleteConfirmationModal({
  handleClose,
  isLoading,
  isFailure,
  handleDeleteClick,
  closeSystemErrorModal,
  warningMessage,
  title
}) {
  return (
    <>
      {!isFailure && (
        <Modal
          title={title}
          open={true}
          handleClose={handleClose}
          titleClass="modal__title_light uppercase"
          closeButtonClass="modal__close-button mr-16 mt-16"
          bodyClass="border-top-grey pl-24 pr-24 pt-16 pb-32"
          large={true}
          modalStyle={{ minHeight: 180 }}
        >
          <p className="font-size-16">{warningMessage}</p>
          <div>
            {isLoading ? (
              <button
                className="primary-button fr univers-67-bold-cond mt-12 mb-24"
                data-testid="spinner-button"
                style={{ minWidth: "150px" }}
              >
                <Spinner
                  className="spinner"
                  fill="#ffffff"
                  height="16px"
                  width="16px"
                />
              </button>
            ) : (
              <button
                className="primary-button fr univers-67-bold-cond mt-12 mb-24"
                data-testid="delete"
                style={{ minWidth: "150px" }}
                onClick={handleDeleteClick}
              >
                {messages.delete.defaultMessage}
              </button>
            )}
            <button
              onClick={handleClose}
              className="secondary-button fr univers-67-bold-cond mt-12 mb-24 mr-12 px-16"
              data-testid="cancel"
              style={{ minWidth: "150px" }}
            >
              {messages.cancel.defaultMessage}
            </button>
          </div>
        </Modal>
      )}
      {isFailure && (
        <SystemErrorModal
          open={isFailure}
          large={true}
          closeModal={closeSystemErrorModal}
          handleExit={closeSystemErrorModal}
          handleTryAgain={handleDeleteClick}
        />
      )}
    </>
  );
}

export default DeleteConfirmationModal;
